// extracted by mini-css-extract-plugin
export default {"Title":"AppTabContainerMobile_Title__8zxCa","rowContainer":"AppTabContainerMobile_rowContainer__Pp7SI","fullItemsView":"AppTabContainerMobile_fullItemsView__AtZlS"};